import { Waitlist } from 'model/Waitlist';
import { FunctionComponent } from 'react';
import styles from './WaitlistBadges.module.scss';

interface WaitlistBadgesProps {
    waitlist: Waitlist;
}

export const WaitlistBadges: FunctionComponent<WaitlistBadgesProps> = ({ waitlist }) => {
    const isOnline = waitlist.source === 'online_booking';
    const isExpired = waitlist.state === 'expired';

    if (!isOnline && !isExpired) {
        return null;
    }

    return (
        <div className={styles.root}>
            {isOnline && <span className={styles.online}>Booked Online</span>}
            {isExpired && <span className={styles.expired}>Expired</span>}
        </div>
    );
};

export default WaitlistBadges;
